import Orders from './orders/Orders';
import Contacts from './Contacts';
import GlobalStyle from './GlobalStyle';
import styled from 'styled-components';
import { colors, fontSizes, radiuses, sizes } from './ui';
import { useState } from 'react';

const Wrapper = styled.div`
  min-height: 100vh;

  .container {
    max-width: ${sizes.s16};
    margin: 0 auto;
    padding: ${sizes.s5} ${sizes.s3} ${sizes.s10};
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    & > header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 0 0 auto;
      gap: ${sizes.s3};
      padding-bottom: ${sizes.s6};

      .brand {
        min-width: 0;

        .brand-name {
          display: block;
          font-size: ${fontSizes.s5};
          font-weight: 700;
          color: ${colors.neutral900};
          letter-spacing: -0.01em;
        }

        .brand-context {
          display: block;
          margin-top: 2px;
          font-size: ${fontSizes.s2};
          color: ${colors.neutral600};
        }
      }

      .buttons {
        display: flex;
      }
    }
    .content {
      flex: 0 0 auto;
      width: 100%;
    }
    .text-block {
      flex: 0 1 auto;
      margin-top: auto;
      padding: ${sizes.s4} ${sizes.s5};
      border: 1px solid #e7cfa4;
      border-radius: ${radiuses.r3};
      background: #fff8eb;

      .eyebrow {
        margin: 0 0 ${sizes.s1};
        color: #8a5a17;
        font-size: ${fontSizes.s2};
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.06em;
      }

      h2 {
        margin: 0 0 ${sizes.s1};
        font-size: ${fontSizes.s5};
      }

      .courier-copy {
        margin: 0;
        color: ${colors.neutral700};
        font-size: ${fontSizes.s3};
        line-height: 1.5;
      }
    }

    @media (max-width: 600px) {
      padding-top: ${sizes.s4};
      padding-bottom: ${sizes.s6};

      & > header {
        padding-bottom: ${sizes.s5};
      }

      .text-block {
        padding: ${sizes.s4};
      }
    }
  }
`;

export default function App() {
  const [isContactsVisible, setContactsVisible] = useState(false);

  const showContacts = () => setContactsVisible(true);
  const hideContacts = () => setContactsVisible(false);

  return (
    <Wrapper>
      <GlobalStyle />
      <div className="container">
        <header>
          <div className="brand" aria-label="Butler Delivery">
            <span className="brand-name">Butler Delivery</span>
            <span className="brand-context">
              {isContactsVisible ? 'Контакты офисов' : 'Отслеживание посылок'}
            </span>
          </div>
          <div className="buttons">
            {isContactsVisible ? (
              <button className="button secondary" onClick={hideContacts}>
                К отслеживанию
              </button>
            ) : (
              <button className="button secondary" onClick={showContacts}>
                Контакты
              </button>
            )}
          </div>
        </header>
        <div className="content">
          <div style={{ display: isContactsVisible ? 'block' : 'none' }}>
            <Contacts />
          </div>
          <div style={{ display: isContactsVisible ? 'none' : 'block' }}>
            <Orders />
          </div>
        </div>
        <aside className="text-block" aria-label="Программа для курьеров">
          <p className="eyebrow">Путешествуете между Бали и Москвой?</p>
          <h2>Станьте курьером</h2>
          <p className="courier-copy">
            Хотите путешествовать по миру почти бесплатно или окупить часть
            билета - вы можете стать нашим курьером в направлении Бали — Москва
            и Москва — Бали
          </p>
        </aside>
      </div>
    </Wrapper>
  );
}
